var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceId({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 7.51337H15.5832",
    stroke: "#4E4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17987 15.0373H4.5603C2.04571 15.0373 1.4082 14.4067 1.4082 11.8915V6.00122C1.4082 3.72251 1.93239 2.9916 3.90864 2.87694C4.10697 2.86978 4.32655 2.86261 4.5603 2.86261H12.4299C14.9445 2.86261 15.582 3.4932 15.582 6.00839V9.1685",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.8128H7.08333",
    stroke: "#4E4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 13.246C15.5832 13.7834 15.4344 14.2922 15.1723 14.7221C14.6836 15.5534 13.784 16.1123 12.7498 16.1123C11.7157 16.1123 10.8161 15.5534 10.3273 14.7221C10.0653 14.2922 9.9165 13.7834 9.9165 13.246C9.9165 11.6623 11.1844 10.3797 12.7498 10.3797C14.3153 10.3797 15.5832 11.6623 15.5832 13.246Z",
    stroke: "#4E4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 13.2457L12.3472 13.9551L13.856 12.5434",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceId);
export default __webpack_public_path__ + "static/media/serviceId.f3652c2e.svg";
export { ForwardRef as ReactComponent };